import { CardString } from 'pokersolver'
import { WalkthroughPlayersIds } from './index'

export type RaiseOrFoldStep = {
  id: WalkthroughPlayersIds
  cards: [CardString, CardString]
  answer: {
    id: 'RAISE' | 'FOLD'
    title: string
    description: string
  }
}

export const RaiseOrFoldCards = (step: number) => {
  const info = RaiseOrFoldSteps[step]
  return {
    [info.id]: info.cards
  }
}

export const RaiseOrFoldSteps: RaiseOrFoldStep[] = [
  // This first step won't actually be shown, it is for the first walkthrough screen.
  {
    id: 'bettina',
    cards: ['2c', '2c'],
    answer: {
      id: 'RAISE',
      title: '',
      description: ''
    }
  },
  {
    id: 'bettina',
    cards: ['Ah', '6d'],
    answer: {
      id: 'FOLD',
      title: 'You should Fold here.',
      description:
        'Just because you have an Ace does not mean this is a strong hand. The 6 makes it less likely to compete strongly against potential high-card or pair combos from opponents. Preserve your chips for a stronger hand and strategic opportunity.'
    }
  },
  {
    id: 'esther',
    cards: ['Kd', 'Qh'],
    answer: {
      id: 'RAISE',
      title: 'You can Raise confidently.',
      description:
        "These are considered Broadway Cards and these are a great starting hand. Remember, the decision to raise is a proactive move that aims to shape the dynamics of the hand. Keep a keen eye on the table, adapt to opponents' play styles, and stay flexible as the hand progresses."
    }
  },
  {
    id: 'dianne',
    cards: ['Kc', '2d'],
    answer: {
      id: 'FOLD',
      title: 'Opt for a wise Fold.',
      description:
        'While the King is a strong high card, the 2 of Diamonds is weak, potentially vulnerable to stronger hands. Folding strategically manages your chip stack, ensuring you allocate resources for more favorable situations.'
    }
  },
  {
    id: 'jane',
    cards: ['Tc', 'Jc'],
    answer: {
      id: 'RAISE',
      title: 'Raising here is the best way to proceed.',
      description:
        'Both cards are 10 or higher. Raising here is a decisive play, leveraging the potential for a strong hand. It also sets the stage to build a larger pot.'
    }
  },
  {
    id: 'tara',
    cards: ['9c', '5s'],
    answer: {
      id: 'FOLD',
      title: 'Folding here is strategic.',
      description:
        'The combination of a 9 and 5, neither forming a pair nor being high cards, makes for a relatively weak hand. You should fold to save your chips for hands with higher potential to win.'
    }
  },
  {
    id: 'bettina',
    cards: ['Jd', '8h'],
    answer: {
      id: 'FOLD',
      title: 'You should Fold here.',
      description:
        "With one face card and a number card that's not connected folding would be a strategic move as the hand doesn't offer a clear advantage."
    }
  },
  {
    id: 'esther',
    cards: ['As', 'Ks'],
    answer: {
      id: 'RAISE',
      title: 'You should Raise confidently here.',
      description:
        "This is one of the top 4 starting hands. It's known as the “Big Slick”. Definitely raise to build the pot and apply pressure on opponents."
    }
  },
  {
    id: 'dianne',
    cards: ['7c', '7h'],
    answer: {
      id: 'RAISE',
      title: 'Choose to Raise.',
      description:
        'A pair of Sevens is a solid starting hand and offers the potential for a strong hand if additional Sevens appear on the board. You should raise!'
    }
  },
  {
    id: 'jane',
    cards: ['8h', '9h'],
    answer: {
      id: 'RAISE',
      title: 'You should Raise.',
      description:
        'These are suited connectors - two consecutive cards of the same suit. Raising here capitalizes on the hand’s potential for a straight or flush” and may make others fold their stronger hands.'
    }
  },
  {
    id: 'tara',
    cards: ['4d', '7c'],
    answer: {
      id: 'FOLD',
      title: 'Preserve chips, choose to Fold.',
      description:
        'The combination of a 4 and 7, neither form a pair nor being high cards, makes for a relatively weak hand. You should fold to save your chips for hands with higher potential to win.'
    }
  },
  // This last step won't actually be shown, it is for the final walkthrough screen.
  {
    id: 'bettina',
    cards: ['2c', '2c'],
    answer: {
      id: 'RAISE',
      title: '',
      description: ''
    }
  }
]
